import * as React from 'react';
import { ServiceOptionItem, ServiceSummaryOptionsType } from '../../ServiceSummary/types';
import ServiceSummaryOption from '../../ServiceSummary/components/ServiceSummaryOption';
import { TravellerInfo } from '../../types';
import { AviaPassengerType } from '@websky/graphql';
import { getPassengerTypeLabel } from '../../utils';

export type CartGroupOptionAdapterType = ServiceSummaryOptionsType & {
	headerType?: 'travellerName' | 'serviceName';
	traveller?: TravellerInfo;
};

interface Props {
	option: CartGroupOptionAdapterType;
	selectedIds?: string[];
	disabled?: boolean;
	onSelect?: (item: ServiceOptionItem) => void;
}

const CartItemOptionAdapter: React.FC<Props> = ({
	option: { headerType, traveller, ...option },
	selectedIds,
	disabled,
	onSelect
}) => {
	if (!option.items.length) {
		return null;
	}

	let itemHeader = option.header;

	if (headerType === 'travellerName') {
		itemHeader =
			traveller.name ??
			`${getPassengerTypeLabel(traveller.type as AviaPassengerType, traveller.supplierTravellerType)} ${
				traveller.typeNumber
			}`;
	}

	return (
		<ServiceSummaryOption
			groupOption={{
				...option,
				header: itemHeader
			}}
			selectedIds={selectedIds}
			disabled={disabled}
			onSelect={onSelect}
		/>
	);
};

export default CartItemOptionAdapter;
